import React, { Fragment, useEffect, useState } from "react";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import FullScreenLoader from "../../../components/fullScreenLoader/fullScreenLoader";
import GetTest from "../../../container/getTest/getTest";
import ChoiceReaction from "../../../container/tChoiceReaction/choiceReaction";
import CPT from "../../../container/tCPT/CPT";
import DualNBack1 from "../../../container/tDualNBack1/dualNBack1";
import TestSummary from "../../../container/testSummary/testSummary";
import FaceNameMix from "../../../container/tFaceNameMix/faceNameMix";
import ListenSpeak from "../../../container/tListenSpeak/listenSpeak";
import ListenSpeakPara from "../../../container/tListenSpeakPara/listenSpeakPara";
import MultiFill from "../../../container/tMultiFill/multiFill";
import MultiTap from "../../../container/tMultiTap/multiTap";
import ShuffleSentence from "../../../container/tShuffleSentence/shuffleSentence";
import SimpleReaction from "../../../container/tSimpleReaction/simpleReaction";
import SimpleSoundReaction from "../../../container/tSimpleSoundReaction/simpleSoundReaction";
import SpeedImgRecall from "../../../container/tSpeedImgRecall/speedImgRecall";
import VisualKeypad from "../../../container/tVisualKeypad/visualKeypad";
import { getCPTData } from "../../../helper/constant/getCPTData";
import { getSpeedImgRecall } from "../../../helper/constant/getSpeedImgRecall";
import { getVisualFNMix } from "../../../helper/constant/getVisualFNMix";
import { getFullScreen } from "../../../helper/fullscreen";
import { setLocalStorage } from "../../../helper/localStorage";
import { objectValidation } from "../../../helper/validation";
import { AnswerContext } from "../../../store/answerStore";
import { HelperContext } from "../../../store/helperStore";
import { LaunchTestContext } from "../../../store/launchTestStore";

export default function Calibration() {
  const history = useHistory();
  const location = useLocation();
  const { launchTestC } = LaunchTestContext();
  const { helperC, dispatchHelper } = HelperContext();
  const { runningQuesId } = helperC;
  const { answerC } = AnswerContext();

  const calibrationData =
    objectValidation(launchTestC.launchTestData) && launchTestC.launchTestData;

  let questions = [];

  // FIXME after fn
  // dual and back test
  calibrationData &&
    objectValidation(calibrationData.tap_nback1) &&
    calibrationData.tap_nback1.data.forEach((dnb) => {
      console.log("dnbData");
      questions = [...questions, { ...dnb, id: "23dnb" }];
    });

  // face name test
  calibrationData &&
    objectValidation(calibrationData.visual_facename_mix) &&
    calibrationData.visual_facename_mix.data.forEach((fnMix, index) => {
      const fnTest = {
        ...getVisualFNMix(helperC.faceData, dispatchHelper, helperC.testType),
      };
      console.log("fnTest", fnTest);
      // id used here has also been used in dummy math test
      questions = [
        ...questions,
        { ...fnTest, id: "11862", test_format: "visual_facename_mix" },
      ];

      console.log("questions", questions);
      // questions = [...questions, ...fnTest.faceArray];
    });

  // simple reaction test
  calibrationData &&
    objectValidation(calibrationData.simple_reaction) &&
    calibrationData.simple_reaction.data.forEach((simpleReaction) => {
      simpleReaction.que.forEach((ques) => {
        questions = [...questions, ques];
      });
    });

  // choice reaction test
  calibrationData &&
    objectValidation(calibrationData.choice_reaction) &&
    calibrationData.choice_reaction.data.forEach((choiceReaction) => {
      choiceReaction.que.forEach((ques) => {
        questions = [...questions, ques];
      });
    });

  // CPT
  console.log("cptData");
  calibrationData &&
    objectValidation(calibrationData.tap_letter) &&
    calibrationData.tap_letter.data.forEach((cpt) => {
      questions = [...questions, ...getCPTData(helperC.testType)];
    });

  // audio test
  calibrationData &&
    objectValidation(calibrationData.audio) &&
    calibrationData.audio.data.forEach((audio) => {
      audio.que.forEach((ques, index) => {
        questions = [...questions, ques];
      });
    });

  // non-audio test
  calibrationData &&
    objectValidation(calibrationData.non_audio) &&
    calibrationData.non_audio.data.forEach((non_audio) => {
      non_audio.que.forEach((ques) => {
        questions = [...questions, ques];
      });
    });

  const getCustomSpeedImgTest = (questions) => {
    let sirTestIndex = questions.findIndex(
      (data) => "listen_speak_series" === data.test_format
    );
    console.log("sirTestIndex", sirTestIndex);

    if (sirTestIndex >= 0) {
      let sirTest = questions[sirTestIndex];
      let mySirTest = [...getSpeedImgRecall([sirTest], "DEMO")];

      //setting dynamic id for calibration test inclusively for sir(speed image recall) test
      mySirTest = mySirTest[0];
      sirTest = { ...mySirTest, id: sirTest.id };
      let allQues = questions;
      allQues[sirTestIndex] = sirTest;
      console.log(allQues);
      return allQues;
    } else {
      return;
    }
  };

  const fnTestIndex = questions.findIndex(
    (ques) => ques.test_format === "visual_facename_mix"
  );

  const nextQusIdAfterFN =
    fnTestIndex !== -1 &&
    questions[fnTestIndex + 1] &&
    questions[fnTestIndex + 1].id;
  setLocalStorage("SET_QUE_ID_AFTER_FN", nextQusIdAfterFN);

  const [warningState, setWarningState] = useState(0);

  useEffect(() => {
    const isReloaded = JSON.parse(localStorage.getItem("isScreenReloaded"));
    isReloaded && history.goBack();
    const handleBeforeunload = (event) => {
      // Cancel the event as stated by the standard.
      event.preventDefault();
      setLocalStorage("isScreenReloaded", true);
      // Older browsers supported custom message
      event.returnValue = "";
    };

    document.addEventListener("fullscreenchange", exitHandler);
    document.addEventListener("webkitfullscreenchange", exitHandler);
    document.addEventListener("mozfullscreenchange", exitHandler);
    document.addEventListener("MSFullscreenChange", exitHandler);
    window.addEventListener("beforeunload", handleBeforeunload);

    return () => {
      document.removeEventListener("fullscreenchange", exitHandler);
      document.removeEventListener("webkitfullscreenchange", exitHandler);
      document.removeEventListener("mozfullscreenchange", exitHandler);
      document.removeEventListener("MSFullscreenChange", exitHandler);
      window.removeEventListener("beforeunload", handleBeforeunload);
      // setIsFullScreen(false);
    };
  }, []);

  function exitHandler() {
    if (
      !document.fullscreenElement &&
      !document.webkitIsFullScreen &&
      !document.mozFullScreen &&
      !document.msFullscreenElement
    ) {
      setWarningState(1);
    }
  }

  const handleBackToTest = () => {
    getFullScreen();
    setWarningState(0);
  };

  const handleBackToHome = () => {
    history.goBack();
  };

  console.log(
    "%claunchtest!",
    "color:red;font-family:system-ui;font-size:2rem;font-weight:bold",
    questions
  );

  return (
    <>
      {launchTestC.loader && <FullScreenLoader />}
      <div className="amaze-started-test">
        {runningQuesId === "submitted" ? (
          <TestSummary questions={questions} />
        ) : (
          calibrationData &&
          questions.map((myQues, index) => {
            return (
              <Fragment key={index}>
                {runningQuesId === myQues.id && (
                  <>
                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      testFormat={"multi_tap"}
                      Component={MultiTap}
                    ></GetTest>

                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      testFormat={"visual_keypad"}
                      Component={VisualKeypad}
                    ></GetTest>

                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      testFormat="single_tap_two"
                      Component={MultiTap}
                    ></GetTest>

                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      testFormat="single_tap"
                      Component={MultiTap}
                    ></GetTest>

                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      testFormat="multi_fill"
                      Component={MultiFill}
                    ></GetTest>

                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      testFormat="letter_typing"
                      Component={MultiFill}
                    ></GetTest>

                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      testFormat="visual_facename_mix"
                      Component={FaceNameMix}
                    ></GetTest>

                    
                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      testFormat="visual_shuffle"
                      Component={ShuffleSentence}
                    ></GetTest>

                    {/* --------------------reaction test-------------------- */}
                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      testFormat="simple_reaction"
                      Component={SimpleReaction}
                    ></GetTest>
                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      testFormat="choice_reaction"
                      Component={ChoiceReaction}
                    ></GetTest>
                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      testFormat="tap_letter"
                      Component={CPT}
                    ></GetTest>
                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      testFormat="tap_nback1"
                      Component={DualNBack1}
                    ></GetTest>

                    {/* --------------------audio test-------------------- */}
                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      testFormat="listen_speak"
                      Component={ListenSpeak}
                    ></GetTest>
                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      testFormat="listen_speak_soundlist"
                      Component={ListenSpeak}
                    ></GetTest>
                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      testFormat="listen_speak_sound"
                      Component={ListenSpeak}
                    ></GetTest>
                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      // this component is same as ListenSpeak
                      testFormat="listen_speak_para"
                      Component={ListenSpeakPara}
                    ></GetTest>
                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      testFormat="listen_sound_differ"
                      Component={MultiTap}
                    ></GetTest>

                    <GetTest
                      questions={getCustomSpeedImgTest(questions)}
                      actualTestFormat={myQues.test_format}
                      testFormat="listen_speak_series"
                      Component={SpeedImgRecall}
                    ></GetTest>

                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      testFormat="simple_reaction_sound"
                      Component={SimpleSoundReaction}
                    ></GetTest>
                    <GetTest
                      questions={questions}
                      actualTestFormat={myQues.test_format}
                      testFormat="listen_speak_fluency"
                      Component={ListenSpeak}
                    ></GetTest>
                  </>
                )}
              </Fragment>
            );
          })
        )}
      </div>
      {warningState === 1 && (
        <FullScreenLoader
          comingFrom={location.state.routeFrom}
          msg="You exited full screen, Your test is still running"
          handleBackToTest={handleBackToTest}
          handleBackToHome={handleBackToHome}
        >

        </FullScreenLoader>
      )}
    </>
  );
}
